import { render, staticRenderFns } from "./fanliJisuanYutiSaq.vue?vue&type=template&id=24936fdf"
import script from "./fanliJisuanYutiSaq.vue?vue&type=script&lang=js"
export * from "./fanliJisuanYutiSaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports